import { render } from "./TableClasses.vue?vue&type=template&id=14c8b574&scoped=true"
import script from "./TableClasses.vue?vue&type=script&lang=js"
export * from "./TableClasses.vue?vue&type=script&lang=js"

import "./TableClasses.vue?vue&type=style&index=0&id=14c8b574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c8b574"]])

export default __exports__